import React from 'react';
import ScrollHideHeader from '../components/layout/scrollHideHeader';
import './login.css';
import { Link } from 'react-router-dom';

const Login = () => {
    return ( <>
    <ScrollHideHeader />
        <main className='alignCenterLogin'> 
            <div className="bgDecor"></div>
            <form className='login'>
                <Link to="/" className='link primary alignStart'>
                    <h5>← Back to Home</h5>
                </Link>
                <h2>Log In</h2>
                <div className="loginField">
                    <label>Email Address</label>
                    <input type="email" />
                </div>
                <div className="loginField">
                    <label>Password</label>
                    <input type="password" />
                </div>
                <button type='submit' className='mainBtn'>Sign In</button>
                <h5>Don't have an account?</h5>
                <button className='secondaryBtn'>Create Account</button>
            </form>
        </main>
    </> );
}
 
export default Login;